module.exports = __webpack_public_path__ + "static/media/Trance.7b112ed2.jpeg";